module.exports = __webpack_public_path__ + "static/media/gold.680dd593.gif";